jQuery( function ( $ ) {

  function resize () {
    $( 'section.step_by_step' ).each( function () {
      const $row = $( '.steps > .row', this );
      const $steps = $( '.step', this );
      const max_height = parseInt( getComputedStyle( $( '.img-box', this ).get(0) ).maxHeight );
      const per_chunk = Math.round( $row.width() / $steps.outerWidth() );
      if ( per_chunk > 1 ) {
        const chunks = $steps.toArray().reduce( ( chunks, one, i ) => {
          const ch = Math.floor( i / per_chunk );
          chunks[ ch ] = ( chunks[ ch ] || [] ).concat( one ); 
          return chunks;
        }, []);
        chunks.forEach( chunk => {
          const $img_boxes = $( '.img-box', $( chunk ) );
          const max = Math.min( max_height, Math.max( ...$img_boxes.toArray().map( el => {
            const $img = $( 'img', el );
            const AR = parseInt( $img.attr( 'height' ) ) / parseInt( $img.attr( 'width' ) );
            return $(el).width() * AR;
          })));
          $img_boxes.height( max );
          const arrow_top = `${ max / 2 }px`;
          $img_boxes.each( function () {
            $(this).closest( '.step' ).get(0).style.setProperty( '--arrow-top', arrow_top );
          });
        });
      }
    });
  }

  resize();
  $( window ).on( 'breakpoint_changed', resize );

})